import { render } from "./TourstatsLondon.vue?vue&type=template&id=1d715b69&scoped=true"
import script from "./TourstatsLondon.vue?vue&type=script&lang=js"
export * from "./TourstatsLondon.vue?vue&type=script&lang=js"

import "./TourstatsLondon.vue?vue&type=style&index=0&id=1d715b69&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d715b69"]])

export default __exports__